export function getColumns(table) {
  if (table === "data_traspasos_recibidos") {
    return [
      { key: "TENANT_ID", label: "TENANT_ID" },
      { key: "NUM_CLI", label: "NUM_CLI" },
      { key: "NOM_CLI", label: "NOM_CLI" },
      { key: "NUM_CUENTA", label: "NUM_CUENTA" },
      { key: "INSTITUCION", label: "INSTITUCION" },
      { key: "TIPO_OPERACION", label: "TIPO_OPERACION" },
      { key: "TOTAL", label: "TOTAL" },
      { key: "NO_OP", label: "NO_OP" }
    ];
  }

  return [
    { key: "NUM_CLI", label: "NUM_CLI" },
    { key: "AP_PAT", label: "AP_PAT" },
    { key: "AP_MAT", label: "AP_MAT" },
    { key: "NOM_CLI", label: "NOM_CLI" },
    { key: "RAZ_SOC", label: "RAZ_SOC" },
    { key: "RFC", label: "RFC" },
    { key: "TIPO_DE_PERSONA", label: "TIPO_DE_PERSONA" },
    { key: "TOTAL", label: "TOTAL" },
    { key: "NO_OP", label: "NO_OP" }
  ];
}

export function formatCellValue(value) {
  if (value === null || value === undefined) return "";
  return String(value);
}

export function escapeForTsv(value) {
  return formatCellValue(value)
    .replace(/\r?\n/g, " ")
    .replace(/\t/g, " ");
}

export function formatValue(key, value) {
  if (value === null || value === undefined) return "";
  if ((key === "TOTAL" || key === "MONTO") && !Number.isNaN(Number(value))) {
    return Number(value).toLocaleString("es-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  if (key === "NO_OP" && !Number.isNaN(Number(value))) {
    return Number(value).toLocaleString("es-MX");
  }

  return String(value);
}

export async function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.left = "-9999px";
  textarea.style.top = "0";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
}
